let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("346hu")).then(() => parcelRequire('4x7m1'));